import getStore from '../store';
import { mutator } from 'satcheljs';
import { setPastDateMarker } from '../actions/searchResultStoreActions';

/**
 * Sets the value whether the past date marker is set.
 */
export let setPastDateMarkerMutator = mutator(setPastDateMarker, item => {
    let store = getStore();
    store.isPastDayFound = item.isPastDayFound;
});
